export interface TimeRange {
  from: number;
  to: number;
}

/**
 * Clamps a range so it lies entirely within the given bounds.
 * If after clamping the range would be invalid (from >= to), returns the full bounds instead.
 * All values are treated as timestamps in milliseconds.
 */
export function clampRangeToBounds(range: TimeRange, bounds: TimeRange): TimeRange {
  const clampedFrom = Math.max(range.from, bounds.from);
  const clampedTo = Math.min(range.to, bounds.to);
  if (clampedFrom < clampedTo) {
    return { from: clampedFrom, to: clampedTo };
  }
  return { from: bounds.from, to: bounds.to };
}
